<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="UnitsEditor"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <DIV
    class="overflow-auto h-100 p-3"
  >
    <ItpBox
      alignItems="center"
      class="mb-3 px-3"
    >
      <strong>
        {{ 'Units'|pgettext('UnitsEditor') }}
      </strong>
      <ItpButton
        icon="fa-sync-alt"
        :text="'Reload'|gettext"
        variant="light"
        size="sm"
        :spinning="actions.reload.isRunning"
        class="ml-3"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
    </ItpBox>
    <ItpDataTable
      tableId="Settings.UnitsEditor"
      editable
      :value="items"
      :columns="b_3343864469950044_columns"
      class="h-100"
      ref="table"
      v-if="loaded"
      @save="evh_3343864469950044_save($event, {})"
      @delete="evh_3343864469950044_delete($event, {})"
    >
    </ItpDataTable>
  </DIV>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "settings.units",
    path: "units",
    component: "UnitsEditor"
  }
)

@Component()
export default class UnitsEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  unitTypes!: any;

  async $$load_unitTypes() {
    return this.$fn.getEnumValuesFromSchema('UnitTypes')
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('list_unit')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_3343864469950044_columns!: any;

  async $$load_b_3343864469950044_columns() {
    return [{
      name: "unit_type",
      type: "select",
      header: this.$fn.pgettext("Unit", "Type"),
      width: "200px",
      required: true,
      options: this.unitTypes,
      valueField: "value",
      textField: "text",
    }
      ,
    {
      name: "symbol",
      header: this.$fn.pgettext("Unit", "Symbol"),
      width: "150px",
      required: true,
    }
      ,
    {
      name: "name",
      header: this.$fn.pgettext("Unit", "Name"),
      width: "200px",
      required: true,
    }
      ,
    {
      name: "description",
      header: this.$fn.pgettext("Unit", "Description"),
      width: "250px",
    }
      ,
    ]
  }

  dataMembers = ['unitTypes', 'items', 'ux', 'b_7315092382398562_modalBindings', 'b_3343864469950044_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        unitTypes: null,
        items: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_3343864469950044_columns: null,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return
    }
    return null;
  }

  async act_7315092382398562_closeModal_5692_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5692, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_3343864469950044_script_5696_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3343864469950044_script_5696, alias=undefined
    $event.data.waitFor(this.$fn.crud('unit').upsert({ ...$event.data.row }))
  }

  async act_3343864469950044_script_5696_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3343864469950044_script_5696, alias=undefined
    return {
      value: () => this.act_3343864469950044_script_5696_getActionArgs_value($event),
    }
  }

  async evh_3343864469950044_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3343864469950044_save.executeFromDOM(this, event, scope);
  }

  async act_3343864469950044_script_5698_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3343864469950044_script_5698, alias=undefined
    $event.data.waitFor(this.$fn.crud('unit').delete({ ...$event.data.row }))
  }

  async act_3343864469950044_script_5698_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3343864469950044_script_5698, alias=undefined
    return {
      value: () => this.act_3343864469950044_script_5698_getActionArgs_value($event),
    }
  }

  async evh_3343864469950044_delete(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3343864469950044_delete.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5692: actions.CloseModalAction;
    evh_7315092382398562_close_5691: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_8320016629450276_reloadComponentData_5694: actions.ReloadComponentDataAction;
    evh_8320016629450276_clickPreventStop_5693: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_3343864469950044_script_5696: actions.ScriptAction;
    evh_3343864469950044_save_5695: actions.EventHandlerImpl;
    evh_3343864469950044_save: actions.EventHandlerGroup;
    act_3343864469950044_script_5698: actions.ScriptAction;
    evh_3343864469950044_delete_5697: actions.EventHandlerImpl;
    evh_3343864469950044_delete: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5692 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5692_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5691 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5692,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5691],
      }
    );
    const act_8320016629450276_reloadComponentData_5694 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_8320016629450276_clickPreventStop_5693 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadComponentData_5694,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_5693],
      }
    );
    const act_3343864469950044_script_5696 = new actions.ScriptAction(
      {
        actionArgs: this.act_3343864469950044_script_5696_getActionArgs,
        events: [],
      }
    );
    const evh_3343864469950044_save_5695 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_script_5696,
        event: "save",
        displayName: "script",
      }
    );
    const evh_3343864469950044_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_3343864469950044_save_5695],
      }
    );
    const act_3343864469950044_script_5698 = new actions.ScriptAction(
      {
        actionArgs: this.act_3343864469950044_script_5698_getActionArgs,
        events: [],
      }
    );
    const evh_3343864469950044_delete_5697 = new actions.EventHandlerImpl(
      {
        action: act_3343864469950044_script_5698,
        event: "delete",
        displayName: "script",
      }
    );
    const evh_3343864469950044_delete = new actions.EventHandlerGroup(
      {
        handlers: [evh_3343864469950044_delete_5697],
      }
    );
    return {
      act_7315092382398562_closeModal_5692,
      evh_7315092382398562_close_5691,
      evh_7315092382398562_close,
      act_8320016629450276_reloadComponentData_5694,
      evh_8320016629450276_clickPreventStop_5693,
      evh_8320016629450276_clickPreventStop,
      act_3343864469950044_script_5696,
      evh_3343864469950044_save_5695,
      evh_3343864469950044_save,
      act_3343864469950044_script_5698,
      evh_3343864469950044_delete_5697,
      evh_3343864469950044_delete,
      reload: act_8320016629450276_reloadComponentData_5694,
    }
  }
}

Vue.component("UnitsEditor", UnitsEditor);

</script>